import React from "react";
import {
  tokens,
  makeStyles,
  Text,
  shorthands,
} from "@fluentui/react-components";
import { FaqSection } from "../../graphql/schema";

const useStyles = makeStyles({
  wrapper: {
    boxShadow: tokens.shadow8,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "650px",
    color: "white",
  },
  titleWraper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  hero: {
    position: "relative",
    zIndex: 1,
    minHeight: "15vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalXXXL
    ),
  },
});

type HeroFaqProps = {
  faqSection: FaqSection;
};
export const HeroFaq = ({ faqSection }: HeroFaqProps) => {
  const classes = useStyles();

  return (
    <article
      className={classes.wrapper}
      style={{ position: "relative", overflow: "hidden", background: "black" }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${faqSection?.image?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          backgroundColor: "black",
        }}
      />

      <section className={classes.hero}>
        <div className={classes.text}>
          <div className={classes.titleWraper}>
            <Text size={900} align="center" weight="bold">
              {faqSection.title ?? ""}
            </Text>
          </div>
        </div>
      </section>
    </article>
  );
};
